module.exports = __webpack_public_path__ + "static/media/boy.3caf2041.png";